import { GET_CLIENT_REGION, GET_CLIENT_REGION_SUCCESS, GET_CLIENT_REGION_ERROR, GET_CLIENT_REGION_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientRegions = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_REGION:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_REGION_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_REGION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_REGION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientRegions;
